import { render, staticRenderFns } from "./componentMenuSidebar.vue?vue&type=template&id=02d9b98f&scoped=true"
import script from "./componentMenuSidebar.vue?vue&type=script&lang=js"
export * from "./componentMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./componentMenuSidebar.vue?vue&type=style&index=0&id=02d9b98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d9b98f",
  null
  
)

export default component.exports